import { VideoStateX } from '../../types/mfc'
import { pubSub } from './pubSub'
import { customStateWrapper, VIDEO_STATE } from './state'

type SetVideoStateOptions = { immediate?: boolean }

const setVideoState = customStateWrapper<VideoStateX, SetVideoStateOptions>(
    (_, { immediate = false } = {}) => {
        pubSub.VIDEO.emit('state', VIDEO_STATE.video, immediate)
    },
)((updates) => {
    VIDEO_STATE.video = { ...VIDEO_STATE.video, ...updates }
})

export const getVideoState = () => VIDEO_STATE.video

export const setVideoVolumeState = (volume: number) => {
    setVideoState({ volume })
}

export const setVideoMuteState = (mute: boolean) => {
    setVideoState({ mute })
}
